import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import IResourceArray = ng.resource.IResourceArray;

export class MedlemsrolleRessurs extends BasisRessurs<l.MedlemsRolleModell> {

    static regNavn = "MedlemsrolleRessurs";

    static forInjisering() {
        return [
            "$resource",
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            MedlemsrolleRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService, ressursFeilhåndtering: RessursFeilhåndtering, gettextCatalog: gettextCatalog) {
        super("medlemsRolle",
            $resource,
            ressursFeilhåndtering, gettextCatalog, {
                'oppdaterRoller': {method: 'POST', url: "/api/medlemsrolle/:id/oppdaterRoller", isArray: true}
            });
    }

    //offentlige metoder

    oppdaterRoller(gruppeId: string, roller: l.MedlemsRolleSpesifikasjon[], vedOk: Function = _.noop): IResourceArray<l.MedlemsRolleModell> {
        return this.ressurs['oppdaterRoller'](
            {id: gruppeId}, 
            roller, 
            vedOk, 
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere roller. Prøv på nytt om litt.")));
    }
}
